import { Box, CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const StyledWrapper = styled(Box)`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  .MuiCircularProgress-circle {
    opacity: 0.5;
  }
`;

const StyledHorizontalWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

interface INotesLoadingProps {}

const NotesLoading = (props: INotesLoadingProps) => {
  return (
    <StyledWrapper>
      <StyledHorizontalWrapper>
        <CircularProgress size={30} thickness={7} />
      </StyledHorizontalWrapper>
    </StyledWrapper>
  );
};

export default NotesLoading;
